import { addNotification } from "./notificationActions"
import { NOT_FOUND } from "../../utils/constants"

import { profileSchemaSignal, profileSchemaLoadedSignal, profileSchemaErrorSignal, profileSchemaVersionSignal } from '../signals/profileSchemaSignals'

export const fetchProfileSchema = async (businessEntityId, utgVersion, manifest, config, accessToken) => {
    if (!manifest) {
        throw new Error("fetchProfileSchema called without a manifest")
    }
    profileSchemaLoadedSignal.value = false
    profileSchemaSignal.value = null
    let manifestProfileEntry
    if (utgVersion == NOT_FOUND) {
        // load the default profile and add an info alert
        manifestProfileEntry = manifest.profiles.find(p => p.default)
        if (!manifestProfileEntry) {
            throw new Error(`Unable to locate either a default or specific profile schema manifest entry for ${utgVersion}.`)
        }
        profileSchemaVersionSignal.value = manifestProfileEntry.utgVersion
        // add an info alert to warn the user that we loaded a default profile schema rather than a specific one for the utgVersion provided
        addNotification(`A default schema designed for UTG ${manifestProfileEntry.utgVersion} is loading. Any changes to this profile will associate it with this schema version. If not appropriate for this profile, please edit it in the legacy environment.`, 'info', false, 'Notice')
    }
    else {
        profileSchemaVersionSignal.value = utgVersion; // allows us to short-circuit future calls when the data is already loaded
        // load the appropriate profile schema from the file linked in the schema manifest
        manifestProfileEntry = manifest.profiles.find(p => p.utgVersion == utgVersion)
        if (!manifestProfileEntry) {
            // no profile schema for this utg. load the default profile and add an info alert
            // find the default profile
            manifestProfileEntry = manifest.profiles.find(p => p.default)
            if (!manifestProfileEntry) {
                throw new Error(`Unable to locate either a default or specific profile schema manifest entry for ${utgVersion}.`)
            }
            // add an info alert to warn the user that we loaded a default profile schema rather than a specific one for the utgVersion provided
            addNotification(`A default schema designed for UTG ${utgVersion} is loading and may not be appropriate for this profile.`, 'info', false, 'Warning')
        }
    }
    // TODO: the manifest file assumes all schemas are in the /react/* folder. 
    // we'll have to adjust the manifest file but for now remove this path
    const filePath = manifestProfileEntry.file.startsWith('/react') ? manifestProfileEntry.file.slice(6) : manifestProfileEntry.file
    return await fetch(filePath).then(
        async (response) => {
            return await response.json().then(
                (data) => {
                    profileSchemaSignal.value = data
                    profileSchemaLoadedSignal.value = true
                    return data
                }
            )
        }
    ).catch(
        (err) => {
            profileSchemaErrorSignal.value = err
            console.log(err)

            addNotification(`Unable to load data due to the following error - ${err}`)
        }
    )
}